var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import Signals from '../../signals/Signals';
import addUserToOrganisation from '../../requests/organisation/addUserToOrganisation';
/**
 *
 */
var AddUserToOrganisationCommand = /** @class */ (function (_super) {
    __extends(AddUserToOrganisationCommand, _super);
    function AddUserToOrganisationCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param organisationName string
     * @param intl
     * @return {*}
     */
    AddUserToOrganisationCommand.prototype.execute = function (organisationName, intl) {
        this.intl = intl;
        var promise = addUserToOrganisation(organisationName);
        promise.then(this.then);
        promise.catch(this.catch);
        return promise;
    };
    /**
     *
     * @param response
     */
    AddUserToOrganisationCommand.prototype.then = function (response) {
        Signals.ShowNotification.dispatch(this.intl.formatMessage({ id: 'notification.organisation.created' }), 'dark', true);
    };
    /**
     *
     * @param error
     */
    AddUserToOrganisationCommand.prototype.catch = function (error) {
        //Signals.ShowNotification.dispatch('Er is iets foutgegaan: ' +  error, 'danger', true);
    };
    return AddUserToOrganisationCommand;
}(Command));
export default AddUserToOrganisationCommand;
